import { ThemeProvider } from "styled-components";
import { ViewStateProvider } from "./ViewStateContext";
import { jsx as _jsx } from "react/jsx-runtime";
export const ContextProviders = props => /*#__PURE__*/_jsx(ViewStateProvider, {
  viewState: props.viewState,
  children: /*#__PURE__*/_jsx(ThemeProvider, {
    theme: props.theme,
    children: props.children
  })
});